"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FormControl2 = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _Select2 = _interopRequireDefault(require("@material-ui/core/Select"));

var _Menu2 = _interopRequireDefault(require("@material-ui/core/Menu"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _ArrowDropDown2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _Grid2 = _interopRequireDefault(require("@material-ui/core/Grid"));

var _InputBase2 = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _FontDownload2 = _interopRequireDefault(require("@material-ui/icons/FontDownload"));

var _FontDownloadOutlined2 = _interopRequireDefault(require("@material-ui/icons/FontDownloadOutlined"));

var _FormatColorText2 = _interopRequireDefault(require("@material-ui/icons/FormatColorText"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Button = function Button() {
  var _listBtn$find, _listBtn$find2;

  var _useState = (0, _react.useState)("Blue Text"),
      _useState2 = _slicedToArray(_useState, 2),
      defaultCheck = _useState2[0],
      setDefaultCheck = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      anchorEl = _useState4[0],
      setAnchorEl = _useState4[1];

  var _useState5 = (0, _react.useState)("Open URL"),
      _useState6 = _slicedToArray(_useState5, 2),
      action = _useState6[0],
      setAction = _useState6[1];

  var listBtn = [{
    name: "Blue Text",
    icon: /*#__PURE__*/_react["default"].createElement(_FormatColorText2["default"], {
      style: {
        color: "#2d7ff9"
      }
    })
  }, {
    name: "Cyan text",
    icon: /*#__PURE__*/_react["default"].createElement(_FormatColorText2["default"], {
      style: {
        color: "#18bfff"
      }
    })
  }, {
    name: "Green Text",
    icon: /*#__PURE__*/_react["default"].createElement(_FormatColorText2["default"], {
      style: {
        color: "#20c933"
      }
    })
  }, {
    name: "Yellow Text",
    icon: /*#__PURE__*/_react["default"].createElement(_FormatColorText2["default"], {
      style: {
        color: "#fcb400"
      }
    })
  }, {
    name: "Orange Text",
    icon: /*#__PURE__*/_react["default"].createElement(_FormatColorText2["default"], {
      style: {
        color: "#fcb400"
      }
    })
  }, {
    name: "Red Text",
    icon: /*#__PURE__*/_react["default"].createElement(_FormatColorText2["default"], {
      style: {
        color: "#f82b60"
      }
    })
  }, {
    name: "Pink Text",
    icon: /*#__PURE__*/_react["default"].createElement(_FormatColorText2["default"], {
      style: {
        color: "#ff08c2"
      }
    })
  }, {
    name: "Purple Text",
    icon: /*#__PURE__*/_react["default"].createElement(_FormatColorText2["default"], {
      style: {
        color: "#8b46ff"
      }
    })
  }, {
    name: "Grey Text",
    icon: /*#__PURE__*/_react["default"].createElement(_FormatColorText2["default"], {
      style: {
        color: "#666666"
      }
    })
  }, {
    name: "Light Blue",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownloadOutlined2["default"], {
      style: {
        color: "#2d7ff9"
      }
    })
  }, {
    name: "Light Cyan",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownloadOutlined2["default"], {
      style: {
        color: "#18bfff"
      }
    })
  }, {
    name: "Light Green",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownloadOutlined2["default"], {
      style: {
        color: "#20c933"
      }
    })
  }, {
    name: "Light Yellow",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownloadOutlined2["default"], {
      style: {
        color: "#fcb400"
      }
    })
  }, {
    name: "Light Orange",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownloadOutlined2["default"], {
      style: {
        color: "#fcb400"
      }
    })
  }, {
    name: "Light Red",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownloadOutlined2["default"], {
      style: {
        color: "#f82b60"
      }
    })
  }, {
    name: "Light Pink",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownloadOutlined2["default"], {
      style: {
        color: "#ff08c2"
      }
    })
  }, {
    name: "Light Purple",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownloadOutlined2["default"], {
      style: {
        color: "#8b46ff"
      }
    })
  }, {
    name: "Light Grey",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownloadOutlined2["default"], {
      style: {
        color: "#666666"
      }
    })
  }, {
    name: "Solid Blue",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownload2["default"], {
      style: {
        color: "#2d7ff9"
      }
    })
  }, {
    name: "Solid Cyan",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownload2["default"], {
      style: {
        color: "#18bfff"
      }
    })
  }, {
    name: "Solid Green",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownload2["default"], {
      style: {
        color: "#20c933"
      }
    })
  }, {
    name: "Solid Yellow",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownload2["default"], {
      style: {
        color: "#fcb400"
      }
    })
  }, {
    name: "Solid Orange",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownload2["default"], {
      style: {
        color: "#fcb400"
      }
    })
  }, {
    name: "Solid Red",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownload2["default"], {
      style: {
        color: "#f82b60"
      }
    })
  }, {
    name: "Solid Pink",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownload2["default"], {
      style: {
        color: "#ff08c2"
      }
    })
  }, {
    name: "Solid Purple",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownload2["default"], {
      style: {
        color: "#8b46ff"
      }
    })
  }, {
    name: "Solid Grey",
    icon: /*#__PURE__*/_react["default"].createElement(_FontDownload2["default"], {
      style: {
        color: "#666666"
      }
    })
  }];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
      fontSize: "0.875rem",
      marginTop: "0.25rem",
      color: "rgba(156, 163, 175, 1)"
    }
  }, "A button that can trigger customizable actions."), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "0.5rem",
      backgroundColor: "rgba(0,0,0,0.05)",
      fontSize: "0.875rem",
      color: "rgba(156, 163, 175, 1)"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
      paddingTop: "1rem",
      paddingBottom: "1rem"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 500
    }
  }, "Label"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingRight: "0.25rem",
      marginTop: "0.25rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_InputBase2["default"], {
    style: {
      backgroundColor: "white",
      borderRadius: "0.25rem",
      border: "2px solid rgba(209, 213, 219,1)",
      paddingLeft: "0.25rem"
    },
    value: "Default"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 500
    }
  }, "Style"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingLeft: "0.25rem",
      height: 36,
      marginTop: "0.25rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      backgroundColor: "#fff",
      display: "inline-flex",
      width: "100%",
      borderRadius: "0.25rem",
      border: "2px solid rgba(0,0,0,0.1)",
      cursor: "pointer"
    },
    onClick: function onClick(e) {
      return setAnchorEl(e.currentTarget);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    container: true,
    justifyContent: "space-between",
    alignItems: "center",
    style: {
      padding: "0 5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    item: true,
    style: {
      marginTop: 5
    }
  }, (_listBtn$find = listBtn.find(function (item) {
    return item.name === defaultCheck;
  })) === null || _listBtn$find === void 0 ? void 0 : _listBtn$find.icon), /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    item: true
  }, (_listBtn$find2 = listBtn.find(function (item) {
    return item.name === defaultCheck;
  })) === null || _listBtn$find2 === void 0 ? void 0 : _listBtn$find2.name), /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_ArrowDropDown2["default"], null)))), /*#__PURE__*/_react["default"].createElement(_Menu2["default"], {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    variant: "menu",
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    style: {
      height: 360,
      overflowY: "auto"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: "0 10px",
      display: "grid",
      gridTemplateColumns: "repeat(".concat(9, ", minmax(0, 1fr))"),
      gap: "0.5rem"
    }
  }, listBtn.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      key: item.name,
      style: {
        cursor: "pointer"
      },
      onClick: function onClick() {
        setDefaultCheck(item.name);
        setAnchorEl(null);
      }
    }, item.icon);
  })))))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 500,
      marginTop: "0.75rem"
    }
  }, "Action"), /*#__PURE__*/_react["default"].createElement(_FormControl2["default"], {
    variant: "outlined",
    size: "small",
    style: {
      height: "100%",
      backgroundColor: "white",
      marginTop: "0.25rem"
    },
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Select2["default"], {
    "native": true,
    value: action,
    onChange: function onChange(e) {
      return setAction(e.target.value);
    },
    style: {
      height: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "Open URL"
  }, "Open URL"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Open in page designer"
  }, "Open in page designer"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Run script"
  }, "Run script"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Preview URL"
  }, "Preview URL"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Send email with SendGrid"
  }, "Send email with SendGrid"))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 500,
      marginTop: "0.75rem"
    }
  }, "URL formula"), /*#__PURE__*/_react["default"].createElement(_InputBase2["default"], {
    style: {
      marginTop: "0.25rem",
      backgroundColor: "white",
      borderRadius: "0.25rem",
      border: "2px solid rgba(209, 213, 219,1)",
      paddingLeft: "0.25rem"
    },
    fullWidth: true
  }))));
};

var _default = Button;
exports["default"] = _default;